import { posts } from '../../mock/posts.json'
import { getDateStamps } from '../../lib/utils'
import PostSection from '../../models/PostSection'

const state = {
  posts,
}

const getters = {
  posts: state => state.posts,
  getPost: state => id => {
    const post = state.posts.find(post => post.id === parseInt(id, 10))
    const sections = post.sections.map(section => {
      if (typeof section === 'string') return PostSection.text(section)
      switch (section.kind) {
        case 'html':
          return PostSection.html(section)
        case 'img':
        case 'image':
          return PostSection.image(section)
        default:
          return new PostSection(section)
      }
    })
    return Object.assign({}, post, { sections })
  },
}

const mutations = {
  setPosts(state, posts) {
    console.debug('vuex.setPosts', posts)
    state.posts = [].concat(posts)
  },
  addPost(state, post) {
    console.debug('vuex.addPost', post)
    const dates = getDateStamps()
    state.posts.push(Object.assign({}, post, dates))
  },
  updatePost(state, changes) {
    const i = state.posts.findIndex(o => o.id === changes.id)
    console.debug('vuex.updatePost', state.posts[i], changes)
    const dates = getDateStamps(true)
    Object.assign(state.posts[i], changes, dates)
  },
}

const actions = {}

export default {
  state,
  getters,
  mutations,
  actions,
}
